const pagesIndividualOperationPackageEn = {
  navigateToHome: "Home",
  navigateToSelectPattern: "Select pattern",
  page: {
    selectPattern: {
      description: "Select a pattern",
    },
    startOperationPackage: {
      startOperationPackage: "Start {{operationPackageName}}",
      processStartedMessage: "{{operationPackageName}} process started!",
      goToHome: "Go to Home",
      requestFor: "Request For",
    },
  },
};

export default pagesIndividualOperationPackageEn;
